import { render } from "./PortasPage.vue?vue&type=template&id=47634720&scoped=true"
import script from "./PortasPage.vue?vue&type=script&lang=js"
export * from "./PortasPage.vue?vue&type=script&lang=js"

import "./PortasPage.vue?vue&type=style&index=0&id=47634720&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47634720"]])

export default __exports__